import styled from "styled-components";

const BottomNavigationWrapper = styled.div`
  max-width: 360px;
  width: 100%;
  position: absolute;
  bottom: 0;
  border-top: 1px solid #f1f3f5;
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 8px 0;
  background-color: white;
  color: #4a5056;

  @media (max-width: 420px) {
    max-width: 420px;
    width: 100%;
    margin: 0;
    border: none;
  }

  div {
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    font-weight: 400;
    font-size: 11px;
    color: #4a5056;
  }

  img {
    max-width: 24px;
  }
`;

export { BottomNavigationWrapper };
